import { http } from '../utils/axios';
import { IJourneyTemplate } from 'shared/interfaces/journeyTemplate.interface';

class JourneyTemplateService {
  private static instance: JourneyTemplateService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): JourneyTemplateService {
    if (!JourneyTemplateService.instance) {
      JourneyTemplateService.instance = new JourneyTemplateService();
    }

    return JourneyTemplateService.instance;
  }

  public getJourneyTemplateInfo = async ({ limit = 20, page = 1 }) => {
    const data = await http<{
      result: IJourneyTemplate[];
      count: number;
    }>({
      url: '/journeyTemplates',
      method: 'GET',
      params: {
        limit,
        page
      }
    });
    return data;
  };
  public createJourneyTemplate = async (payload: any) => {
    //TCreateJourneyTemplate
    const { data } = await http<IJourneyTemplate>({
      url: '/journeyTemplates',
      method: 'POST',
      data: payload
    });

    return data;
  };

  public getOneJourneyTemplate = async (slug: string) => {
    const { data } = await http<IJourneyTemplate>({
      url: `/journeyTemplates/${slug}`,
      method: 'GET'
    });
    return data;
  };

  public updateJourneyTemplate = async (payload: {
    id: string;
    data: IJourneyTemplate;
  }) => {
    const { data } = await http<IJourneyTemplate>({
      url: `/journeyTemplates/${payload.id}`,
      method: 'PUT',
      data: payload.data
    });

    return data;
  };
}

const instance = JourneyTemplateService.getInstance();

export default instance;
